import {
  CREATE_JOB_CARD_SUCCESS,
  FETCH_JOB_CARD_REPORT_SUCCESS,
  FETCH_JOB_CARD_SEARCH_SUCCESS,
  FETCH_JOB_CARD_SUCCESS,
  GET_ALL_JOBS_START,
  GET_ALL_JOBS_SUCCESS,
  GET_ALL_OPEN_JOBS_SUCCESS,
  GET_COMPLAINT_DATA_SUCCESS,
  GET_JOB_CARD_DASHBOARD_DOWNLOAD_START,
  GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS,
  GET_JOB_CARD_SUCCESS,
  GET_LOCATION_BY_QUERY,
  SAVE_JOB_CARD_QUERY,
  UNMOUNT_JOB_CARD,
  // GET_IOT_JOB_CARD_SUCCESS,
  // SAVE_IOT_JOB_CARD_QUERY,
  FETCH_JOB_CARD_COSTING_REPORT_SUCCESS,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  location: [],
  complaint: [],
  report: {},
  allJobsLoading: false,
  allJobs: [],
  allOpenJobs: [],
  searchData: [],
  dashboardJobDownloadLoading: false,
  iotResources: [],
  iotQuery: {},
  iotTotal: 0,
  costingReportData: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_JOB_CARD_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_JOB_CARD_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    // case GET_JOB_CARD_FROM_JOB_ALLOCATION: {
    //   return {
    //     ...state,
    //     resources: action.data,
    //   };
    // }

    case CREATE_JOB_CARD_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case UNMOUNT_JOB_CARD: {
      return {
        ...state,
        complaint: []
      };
    }

    case GET_LOCATION_BY_QUERY: {
      return {
        ...state,
        location: action.data,
      };
    }

    case GET_COMPLAINT_DATA_SUCCESS: {
      return {
        ...state,
        complaint: action.data,
      };
    }

    case FETCH_JOB_CARD_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_JOB_CARD_SEARCH_SUCCESS: {
      return {
        ...state,
        searchData: action.data,
      };
    }


    case FETCH_JOB_CARD_REPORT_SUCCESS: {
      return {
        ...state,
        report: action.data,
      }
    }

    case GET_ALL_JOBS_START: {
      return {
        ...state,
        allJobsLoading: true
      };
    }

    case GET_ALL_OPEN_JOBS_SUCCESS: {
      return {
        ...state,
        allJobsLoading: false,
        allOpenJobs: action.data
      };
    }

    case GET_ALL_JOBS_SUCCESS: {
      return {
        ...state,
        allJobsLoading: false,
        allJobs: action.data
      };
    }

    case GET_JOB_CARD_DASHBOARD_DOWNLOAD_START: {
      return {
        ...state,
        dashboardJobDownloadLoading: true,
      };
    }

    case GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        dashboardJobDownloadLoading: false,
      };
    }

    // case GET_IOT_JOB_CARD_SUCCESS: {
    //   const query = { ...state.iotQuery };
    //   query.pagination.total = action.count;

    //   return {
    //     ...state,
    //     iotQuery: query,
    //     iotResources: action.data,
    //     iotTotal: action.total,
    //   };
    // }

    // case SAVE_IOT_JOB_CARD_QUERY: {
    //   return {
    //     ...state,
    //     iotQuery: action.query,
    //   };
    // }

    case FETCH_JOB_CARD_COSTING_REPORT_SUCCESS: {
      return {
        ...state,
        costingReportData: action.data,
      };
    }

    default:
      return state;
  }
}
